import { gql } from '@apollo/client';

const WarrantyIssueInfo = gql`
  fragment WarrantyIssueInfo on WarrantyIssue {
    id
    canDelete
    name
    description
    createdAt
    updatedAt
  }
`;

export default WarrantyIssueInfo;
